import { showToast } from '@lokalise/louis'
import { useAssignAiConfigurationToProjectsMutation } from '@lokalise/shared'
import { useCallback } from 'react'
import type { AnyAiProfile } from '../types/profiles'
import {
  appHttpClient,
  authenticatedPublicApiHeaderBuilder,
  getTeamIdFromSession,
} from '../utils/api'
import { showUnexpectedErrorToast } from '../utils/toast'

type UseDeactivateProfileProps = {
  profile: AnyAiProfile
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

type DeactivateProps = {
  profileId: string
}

export const useDeactivateProfile = ({
  profile,
  onSuccess,
  onError,
}: UseDeactivateProfileProps) => {
  const teamId = getTeamIdFromSession()

  const { mutate: assignAiConfig, isPending } = useAssignAiConfigurationToProjectsMutation(
    appHttpClient,
    authenticatedPublicApiHeaderBuilder,
    {
      onSuccess: () => {
        showToast({
          type: 'success',
          title: `${profile.name} has been deactivated successfully`,
          description: `${profile.projects.length} project${profile.projects.length !== 1 ? 's' : ''} removed from ${profile.name}.`,
        })

        onSuccess?.()
      },

      onError: (error) => {
        showUnexpectedErrorToast()
        onError?.(error)
      },
    },
  )

  const deactivate = useCallback(
    ({ profileId }: DeactivateProps) => {
      assignAiConfig({
        project_ids: [],
        force: true,
        teamId,
        configurationId: profileId,
      })
    },
    [assignAiConfig, teamId],
  )

  return { deactivate, isPending }
}
